import { useSelector } from 'react-redux'
import SeedCropSelectors from 'modules/domain/seedCrop/selectors'
import { Progress, ResourceHook } from 'modules/types'
import SeedCropActions from 'modules/domain/seedCrop/duck'
import { SeedCrop } from 'modules/domain/seedCrop/types'
import { useEffect } from 'react'
import { useAction, useDidMount, usePageQuery } from '@agro-club/frontend-shared'

export const useSeedCropList: ResourceHook<SeedCrop[], void[]> = () => {
  const progress = useSelector(SeedCropSelectors.listFetchProgress)
  const list = useSelector(SeedCropSelectors.seedCropList)
  const page = usePageQuery()
  const fetchAction = useAction(SeedCropActions.listRequested, page ? { page } : {})

  useDidMount(() => {
    if (progress !== Progress.SUCCESS) {
      fetchAction()
    }
  })

  return [progress, list]
}

export const useSeedCrop: ResourceHook<SeedCrop, [string]> = (id: string) => {
  const meta = useSelector((state) => SeedCropSelectors.meta(state, id))
  const seedCrop = useSelector((state) => SeedCropSelectors.seedCrop(state, id))
  const fetchAction = useAction(SeedCropActions.itemRequested, id)

  useDidMount(() => {
    if (!seedCrop || seedCrop.id !== id) {
      fetchAction()
    }
  })

  return [meta.fetchProgress, seedCrop]
}

export const useSeedCropById: ResourceHook<SeedCrop, [string]> = (id: string) => {
  const meta = useSelector((state) => SeedCropSelectors.meta(state, id))
  const item = useSelector((state) => SeedCropSelectors.seedCrop(state, id))
  const fetchAction = useAction(SeedCropActions.itemRequested, id)

  useEffect(() => {
    if (!item || id !== item.id) {
      fetchAction()
    }
  }, [item, fetchAction, id])

  return [meta.fetchProgress, item]
}
